import { Component, OnInit } from '@angular/core';
import { NatureProduitCrm } from '../../core/model/produitCrm/natureProduitCrm';
import { Router } from '@angular/router';
import { AddNatureProduitCrmComponent } from './add-nature-produit-crm/add-nature-produit-crm.component';
import { NgbdModalConfirm } from 'src/app/core/services/utils/modal-confirm';
import { finalize } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ProduitCrmService } from '../../core/service/produit-crm.service';
import { SetTypeChampProduitCrmComponent } from './set-type-champ-produit-crm/set-type-champ-produit-crm.component';
import { SetTypeDocumentProduitCrmComponent } from './set-type-document-produit-crm/set-type-document-produit-crm.component';

@Component({
  selector: "app-nature-produit-crm",
  templateUrl: "./nature-produit-crm.component.html",
  styleUrls: ["./nature-produit-crm.component.scss"]
})
export class NatureProduitCrmComponent implements OnInit {
  natureProduitCrm: NatureProduitCrm[];

  constructor(
    private _router: Router,
    private modalService: NgbModal,
    private _produitCrmService: ProduitCrmService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit() {
    this.getListNatureProduitCrm();
  }

  getListNatureProduitCrm() {
    this._produitCrmService.getListNatureProduitCrm().subscribe(data => {
      console.log(data);
      this.natureProduitCrm = data;
    });
  }

  showDetail(group: NatureProduitCrm) {}

  editDetail(natureProduitCrm: NatureProduitCrm) {
    const modalRef = this.modalService.open(AddNatureProduitCrmComponent, {
      centered: true,
      backdropClass: "light-blue-backdrop",
      backdrop: "static",
      windowClass: "my-app-app-modal-class"
    });
    modalRef.componentInstance.natureProduitCrm = natureProduitCrm;
    modalRef.result.then(
      result => {
        console.log("result", result);
        // on close
        this.getListNatureProduitCrm();
      },
      reason => {
        console.log("reason", reason);
        // on dismiss
      }
    );
  }

  deleteDetail(row) {
    //message en popup
    const modalConfirmRef = this.modalService.open(NgbdModalConfirm, {
      centered: true
    });
    modalConfirmRef.componentInstance.title = "Suppression #" + row.id;
    modalConfirmRef.componentInstance.libelle = row.libelleNature;
    modalConfirmRef.componentInstance.queryMessage =
      "Etes-vous sûr de vouloir supprimer cet élément";
    modalConfirmRef.componentInstance.description =
      '<span class="text-danger"> Cette opération sera définitive.</span>';
    modalConfirmRef.componentInstance.btnMessage = "Oui, supprimer";

    modalConfirmRef.result.then(
      result => {
        this.spinner.show();
        this._produitCrmService
          .delete(row.id)
          .pipe(
            finalize(() => {
              this.spinner.hide();
            })
          )
          .subscribe(data => {
            this.getListNatureProduitCrm();
          });
      },
      reason => {
        console.log("reason", reason);
        //on dismiss
      }
    );
  }

  addNatureProduitCrm() {
    const modalRef = this.modalService.open(AddNatureProduitCrmComponent, {
      centered: true,
      backdropClass: "light-blue-backdrop",
      backdrop: "static",
      windowClass: "my-app-app-modal-class"
    });
    //modalRef.componentInstance.profile = this.profile;
    modalRef.result.then(
      result => {
        console.log("result", result);
        // on close
        this.getListNatureProduitCrm();
      },
      reason => {
        console.log("reason", reason);
        // on dismiss
      }
    );
  }

  setTypeDocumentProduitCrm(natureProduitCrm: NatureProduitCrm) {
    const modalRef = this.modalService.open(
      SetTypeDocumentProduitCrmComponent,
      {
        centered: true,
        backdropClass: "light-blue-backdrop",
        backdrop: "static",
        windowClass: "my-app-app-modal-class",
        size: "lg"
      }
    );
    modalRef.componentInstance.natureProduitCrm = natureProduitCrm;
    modalRef.componentInstance.natureProduitCrmId = natureProduitCrm.id;
    modalRef.result.then(
      result => {
        console.log("result", result);
        // on close
        this.getListNatureProduitCrm();
      },
      reason => {
        console.log("reason", reason);
        // on dismiss
      }
    );
  }

  setChampProduitCrm(natureProduitCrm: NatureProduitCrm) {
    const modalRef = this.modalService.open(SetTypeChampProduitCrmComponent, {
      centered: true,
      backdropClass: "light-blue-backdrop",
      backdrop: "static",
      windowClass: "champ-modal-class"
    });
    modalRef.componentInstance.natureProduitCrm = natureProduitCrm;
    modalRef.componentInstance.natureProduitCrmId = natureProduitCrm.id;
    modalRef.result.then(
      result => {
        console.log("result", result);
        // on close
        this.getListNatureProduitCrm();
      },
      reason => {
        console.log("reason", reason);
        // on dismiss
      }
    );
  }
}
